// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__1LDxL","footer":"ModalError_footer__3fam_"};